import {createSelector} from 'reselect'

export const getJobFieldSpecification = createSelector(
  state => state && state.user && state.user.list && state.user.list.jobFieldSpecification,
  jobFieldSpecification => jobFieldSpecification
)
